import { createAction, props } from '@ngrx/store';
import { Language } from 'src/app/modules/core/languages/language.model';
import { AuthToken } from '../../authentication/store/auth';
import { ProfilePreferences } from './notification-prefs.model';

//import { Notification } from './notifications.models';
import { QueryResult, QueryParams } from '../../core/store/models';

export const loadAvailableLanguagesForLogin = createAction('[NotificationPrefs] Load Available Languages For Login');
export const loadAvailableLanguagesForLoginComplete = createAction(
  '[NotificationPrefs] Load Available Languages For Login Complete',
  props<{ languages: string[] }>()
);

export const loadAvailableLanguages = createAction('[NotificationPrefs] Load Available Languages', props<{ organizationUId: string }>());
export const loadAvailableLanguagesComplete = createAction(
  '[NotificationPrefs] Load Available Languages Complete',
  props<{ languages: Language[] }>()
);

export const setError = createAction('[NotificationPrefs] Set Error', props<{ err: { message: string } }>());

export const sendOneTimeAuthEmail = createAction(
  '[NotificationPrefs] Send Onetime Auth Email',
  props<{ orgCode: string; email: string; cultureCode: string; recaptchaToken: string }>()
);
export const sendOnTimeAuthEmailComplete = createAction('[NotificationPrefs] Send Onetime Auth Email Complete', props<{ email: string }>());

export const sendOneTimeAuthPhone = createAction(
  '[NotificationPrefs] Send Onetime Auth Phone',
  props<{ orgCode: string; phone: string; cultureCode: string; recaptchaToken: string }>()
);
export const sendOnTimeAuthPhoneComplete = createAction('[NotificationPrefs] Send Onetime Auth Phone Complete', props<{ phone: string }>());

export const sendOneTimeAuthWhatsApp = createAction(
  '[NotificationPrefs] Send Onetime Auth WhatsApp',
  props<{ orgCode: string; phone: string; cultureCode: string; recaptchaToken: string }>()
);
export const sendOneTimeAuthWhatsAppComplete = createAction('[NotificationPrefs] Send Onetime Auth WhatsApp Complete');

export const cancelEnterCode = createAction('[NotificationPrefs] Cancel Enter Code');

export const processLoginAuthCodeForEmail = createAction(
  '[NotificationPrefs] Process Login Auth Code For Email',
  props<{ orgCode: string; code: string; cultureCode: string }>()
);

export const processLoginAuthCodeForEmailComplete = createAction(
  '[NotificationPrefs] Process Login Auth Code For Email Complete',
  props<{ authToken: AuthToken }>()
);

export const processLoginAuthCodeForPhone = createAction(
  '[NotificationPrefs] Process Login Auth Code For Phone',
  props<{ orgCode: string; code: string; cultureCode: string }>()
);

export const processLoginAuthCodeForPhoneComplete = createAction(
  '[NotificationPrefs] Process Login Auth Code For Phone Complete',
  props<{ authToken: AuthToken }>()
);

export const processAuthCodeForEmail = createAction(
  '[NotificationPrefs] Process Auth Code for Email',
  props<{ orgCode: string; code: string; userKey: string; fieldName: string }>()
);

export const processAuthCodeForEmailComplete = createAction(
  '[NotificationPrefs] Process Auth Code for Email Complete',
  props<{ preferences: ProfilePreferences }>()
);

export const processAuthCodeForPhone = createAction(
  '[NotificationPrefs] Process Auth Code for Phone',
  props<{ orgCode: string; code: string; userKey: string; fieldName: string }>()
);

export const processAuthCodeForPhoneComplete = createAction(
  '[NotificationPrefs] Process Auth Code for Phone Complete',
  props<{ preferences: ProfilePreferences }>()
);

export const processAuthCodeForWhatsApp = createAction(
  '[NotificatonPrefs] Process Auth Code for WhatsApp',
  props<{ orgCode: string; code: string; userKey: string; fieldName: string }>()
);

export const processAuthCodeForWhatsAppComplete = createAction(
  '[NotificationPrefs] Process Auth Code for WhatsApp Complete',
  props<{ preferences: ProfilePreferences }>()
);

export const logoutPreferences = createAction('[NotificationPrefs] Logout Preferences');

export const logoutPreferencesComplete = createAction('[NotificationPrefs] Logout Preferences Complete');

export const getNotificationPreferences = createAction('[NotificationPrefs] Get Notification Preferences');

export const getNotificationPreferencesComplete = createAction(
  '[NotificationPrefs] Get Notification Preferences Complete',
  props<{ preferences: ProfilePreferences }>()
);

export const updateNotificationPreferences = createAction(
  '[NotificationPrefs] Update Notification Preferences',
  props<{ preferences: ProfilePreferences; close?: boolean }>()
);

export const updateNotificationPreferencesComplete = createAction(
  '[NotificationPrefs] Update Notification Preferences Complete',
  props<{ preferences: ProfilePreferences }>()
);

export const showLoginChoice = createAction('[NotificationPrefs] Show Login Choice');

export const showLoginEmail = createAction('[NotificationPrefs] Show Login Email');

export const showLoginPhone = createAction('[NotificationPrefs] Show Login Phone');

export const showOptInSmsPhone = createAction('[NotificationPrefs] Show Login Phone SMS Opt In', props<{ phone: string }>());

export const showVerifyCodeEmail = createAction('[NotificationPrefs] Show Verify Code Email');

export const showVerifyCodePhone = createAction('[NotificationPrefs] Show Verify Code Phone');

export const changeEmailField = createAction('[NotificationPrefs] Change Email Field', props<{ emailField: string }>());

export const cancelChangeEmailField = createAction('[NotificationPrefs] Cancel Change Email Field');

export const changePhoneField = createAction('[NotificationPrefs] Change Phone Field', props<{ phoneField: string }>());

export const cancelChangePhoneField = createAction('[NotificationPrefs] Cancel Change Phone Field');

export const changeWhatsAppField = createAction('[NotificationPrefs] Change WhatsApp Field', props<{ whatsAppField: string }>());

export const cancelChangeWhatsAppField = createAction('[NotificationPrefs] Cancel Change WhatsApp Field');

export const optInSmsAuthentication = createAction(
  '[NotificationPrefs] Opt In SMS Authentication',
  props<{ orgCode: string; phone: string; cultureCode: string; recaptchaToken: string }>()
);
